// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { currentUser, userProfile } = useAuth();
  const location = useLocation();

  // Show loading while auth is being determined
  if (currentUser === undefined || (currentUser && userProfile === undefined)) {
    return (
      <div className="container mt-3">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted">Checking authentication...</p>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to home if admin route but user is not admin
  if (adminOnly && userProfile?.role !== 'admin') {
    return (
      <div className="container mt-3">
        <div className="alert alert-warning">
          <h4 className="alert-heading">
            {/* Inline SVG — replaces the Font Awesome icon so the render-blocking FA CDN stylesheet could be removed from index.html */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="me-2" style={{ display: 'inline-block', verticalAlign: '-3px' }}>
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><path d="M12 9v4" /><path d="M12 17h.01" />
            </svg>
            Access Denied
          </h4>
          <p className="mb-0">
            You don't have permission to access this page. 
            This section is only available to administrators.
          </p>
          <hr />
          <div className="mb-0">
            <button 
              className="btn btn-primary"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;